'use client';
import { useI18n } from '@locales/client';
import { BodyTextRegularPrimary } from '@/shared/ui/typography';
import { RenderHomeGameSections } from '@/widgets/game-sections/ui/render-home-game-sections';
import { PopularGamesSkeleton } from '@/widgets/game-sections/ui/popular-games-skeleton';
import { NotFound, PopularGamesWrapper } from './styles';
import type { HomeGamesResponse } from '@/widgets/game-sections/ui/home-games-types';

interface PopularGamesSectionProps {
  homeGamesData: HomeGamesResponse | undefined;
  homeGamesError: unknown;
  hasAnyGames: boolean | null;
  openNotAllowedModal?: () => void;
  setCurrentGame: (game) => void;
}

export const PopularGamesSection = ({
  homeGamesData,
  homeGamesError,
  hasAnyGames,
  openNotAllowedModal,
  setCurrentGame,
}: PopularGamesSectionProps) => {
  const t = useI18n();

  return (
    <PopularGamesWrapper>
      {!homeGamesData && !homeGamesError && <PopularGamesSkeleton />}
      {(homeGamesError || (homeGamesData && !hasAnyGames)) && (
        <NotFound>
          <BodyTextRegularPrimary color="#AFAFAF">
            {t('common.filter.provider.nothing')}
          </BodyTextRegularPrimary>
        </NotFound>
      )}
      {homeGamesData && hasAnyGames && (
        <RenderHomeGameSections
          sections={homeGamesData}
          openNotAllowedModal={openNotAllowedModal}
          setCurrentGame={setCurrentGame}
        />
      )}
    </PopularGamesWrapper>
  );
};
